import React from 'react';
import { CircularProgress } from '@mui/material';

interface IProps {
  fixed?: boolean;
}

const useStyles = () => ({
  container: {
    margin: 'auto',
  }  
});

export const Loader = ({ fixed }: IProps) => {
  const classes = useStyles();

  return (
    <div style={classes.container}>
      <CircularProgress disableShrink />
    </div>
  );
};
